<template>
    <div class="container mx-auto max-w-xs pt-8">
        <pause-deliveries
            v-if="subscription"
            :subscriptionId="subscriptionId"
            :addressId="addressId"/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PauseDeliveries from '@/components/partials/account/my-delivery-schedule/manage-delivery/PauseDeliveries';

export default {
    name: 'PauseOrCancel',
    components: {
        PauseDeliveries,
    },
    computed: {
        ...mapGetters({
            subscription: 'subscription/getActiveSubscription',
        }),
        subscriptionId() {
            return this.subscription?.id;
        },
        addressId() {
            return this.subscription?.delivery_address_id;
        },
    },
};
</script>
